import { useFeatureFlags } from '@/composable/services/useFeatureFlags'
import { useAuthStore } from '@/stores/auth.store'
import { useRouterStore } from '@/stores/router.store'
import { useUserStore } from '@/stores/user.store'
import { effectScope, getCurrentScope } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { routeNames } from '@/router/router-constants'
import { routes } from '@/router/routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  const userStore = useUserStore()
  const routerStore = useRouterStore()
  if (!to.meta.publicRoute && !authStore.logged()) {
    next({ name: routeNames.login, query: { redirect: to.fullPath } })
  } else if (to.meta.permission) {
    try {
      await userStore.init()
    } catch (error) {
      routerStore.initialLoading = false
      routerStore.serverError = true
      return next({ name: routeNames.login })
    }

    if (userStore.hasPermission(to.meta.permission)) {
      next()
    } else {
      next({ name: routeNames.unauthorized })
    }
  } else {
    next()
  }
})

router.beforeEach(async (to, from, next) => {
  const scope = getCurrentScope() || effectScope()
  await scope.run(async () => {
    const { isFeatureActive, initFeatureFlags } = useFeatureFlags()
    const routerStore = useRouterStore()
    try {
      await initFeatureFlags()
    } catch (error) {
      routerStore.initialLoading = false
      routerStore.serverError = true
      return next({ name: routeNames.login })
    }

    routerStore.initialLoading = false
    if (to.meta.featureFlag && !isFeatureActive(to.meta.featureFlag)) {
      next({ name: routeNames.unauthorized })
    } else {
      next()
    }
  })
  scope.stop()
})

export { router }
